(ns frontend.lp-portal.event
  (:require
   [re-frame.core :as rf]
   [frontend.browser-utils :as bu]
   [frontend.controller.websocket.event :as ws]
   [common.time :as c-time]
   [frontend.lp-portal.routes :as routes]
   [frontend.lp-portal.sub :as sub]
   [frontend.controller.routing.event :as routing]
   [frontend.ui.page.lp-portal.landing-page.event :as landing-page-event]
   [cljs.core.async :as async]
   [cljs-http.client :as http]
   [promesa.core :as p]
   [frontend.conn :as conn]
   [ajax.core :as ajax]
   [frontend.logging :as logging]
   [potpuri.core :as pp]))

(rf/reg-cofx
 ::now
 (fn [cofx _data]                                           ;; _data unused
   (assoc cofx :now (js/Date.))))

(rf/reg-event-fx
 ::on-lp-portal-initial-data
 (fn [{:keys [db] :as cofx} [_ {:keys [body] :as args}]]
   (let [{:keys [tenant email]} body]
     {:db (-> db
              (assoc-in sub/session-data-path body)
              (assoc-in sub/portal-status-path
                        (if (and tenant email)
                          :lp-portal.status/ok
                          :lp-portal.status/no-access)))
      :fx (concat [[:dispatch [::portal-guests]]]
                  (when-let [on-init (get-in db sub/init-dispatch-path)]
                    [[:dispatch on-init]]))})))

(rf/reg-event-fx
 ::on-lp-portal-initial-failed
 (fn [{:keys [db] :as cofx} [_ args]]
   (logging/unimplemented "Failed to load initial lp-portal data")
   {:db (assoc-in db sub/portal-status-path :lp-portal.status/error)
    ::routing/push-state {:handler     ::routes/loading-error
                          :path-params {:status :error}}}))

(rf/reg-event-fx                  ;; register an event handler
 ::initialize-portal              ;; for events with this name
 (fn [{:keys [db] :as cofx} args] ;; get the co-effects and destructure the event
   {:db         (assoc-in db sub/portal-status-path :lp-portal.status/authenticating)
    :http-xhrio {:method          :post
                 :uri             "/lp-portal/api/initial-data"
                 :params          {}
                 :timeout         30000
                 :format          (ajax/transit-request-format)
                 :response-format (ajax/transit-response-format)
                 :on-success      [::on-lp-portal-initial-data]
                 :on-failure      [::on-lp-portal-initial-failed]}}))

(rf/reg-event-fx
 ::reload-landing-page
 (fn [{db :db} _]
   (logging/performance "Simulate load Landing page data")
   {::routing/push-state {:handler     ::routes/loading-error
                          :path-params {:status :loading}}
    :http-xhrio {:method          :post
                 :uri             "/lp-portal/api/landing-page-data"
                 :params          {}
                 :timeout         30000
                 :format          (ajax/transit-request-format)
                 :response-format (ajax/transit-response-format)
                 :on-success      [::landing-page-event/on-landing-page-data]
                 :on-failure      [::landing-page-event/on-landing-page-failed]}}))

(rf/reg-event-fx
 ::on-app-config
 (fn [{db :db} [_ {:keys [body] :as args}]]
   {:db (-> db
            (assoc-in sub/app-config-path body)
            (assoc-in sub/csrf-token-path (:csrf-token body)))
    :fx [[:dispatch [::routing/initialize-routing routes/lp-routes]]
         [:dispatch [::initialize-portal]]]}))

(rf/reg-event-fx
 ::load-app-config
 (fn [{db :db} [_]]
   {:db         (assoc-in db sub/portal-status-path :lp-portal.status/loading)
    :http-xhrio {:method          :get
                 :uri             "/lp-portal/api/app-config"
                 :params          {}
                 :timeout         30000
                 :format          (ajax/transit-request-format)
                 :response-format (ajax/transit-response-format)
                 :on-success      [::on-app-config]
                 :on-failure      [::on-app-config-error!]}}))

(rf/reg-event-fx
 ::ws-connected
 (fn [{db :db} [_]]
   {:db (assoc-in db sub/portal-status-path :lp-portal.status/loading)
    :fx [[:dispatch [::load-app-config]]]}))

(rf/reg-event-fx
 ::ws-error
 (fn [{:keys [db] :as cofx} [_]]
   (logging/unimplemented "WS error handler")
   {:db (assoc-in db sub/portal-status-path :lp-portal.status/disconnected)}))


(rf/reg-event-fx
 ::ws-message
 (fn [cofx [_ args]]
   (let [{:keys [db]} cofx]
     {:db (assoc db :last-server-message (c-time/now-millis))})))

(rf/reg-event-fx
 ::simulate-ok
 (fn [{db :db} [_ email _]]
   {:db (-> db
            (assoc-in sub/simulated-email-path email))
    :fx [[:dispatch [::reload-landing-page]]]}))

(rf/reg-event-fx
 ::simulate-failed
 (fn [{db :db} [_ err]]
   (logging/unimplemented "Simulate user change failed : " err)))

(rf/reg-event-fx
 ::simulate-user
 (fn [{db :db} [_ simulated-email]]
   {:db         (assoc-in db sub/simulate-processing-path true)
    :http-xhrio {:method          :post
                 :uri             "/lp-portal/api/simulate-user"
                 :params          {:email simulated-email}
                 :timeout         30000
                 :format          (ajax/transit-request-format)
                 :response-format (ajax/transit-response-format)
                 :on-success      [::simulate-ok simulated-email]
                 :on-failure      [::simulate-failed simulated-email]}
   }))

(rf/reg-event-fx
 ::logout
 (fn [cofx _]
   {:redirect {:url "/login/"}}))

(rf/reg-event-fx
 ::no-access-flow
 (fn [cofx [_ msg]]
   (let [{:keys [db]} cofx]
     {:db      (assoc db :no-access-message msg)
      :timeout {:id    :logout-message
                :event [::logout]
                :time  2000}})))

(rf/reg-event-fx
 ::set-cover-image-url
 (fn [{:keys [db] :as cofx} [_ url]]
   {:db (assoc db
               :cover-image-url url
               :uploading-cover-image false)}))

(rf/reg-event-fx
 ::set-content-url
 (fn [{:keys [db] :as cofx} [_ url]]
   {:db (assoc db
               :content-url url
               :uploading-content false)}))

(rf/reg-event-fx
 ::upload-token-created
 (fn [{db :db} [_ file module-name resp]]
   (let [token (-> resp
                   :body
                   :token)]
     (async/go
      (let [resp (async/<! (http/post "/lp-portal-file-upload/api/file-upload"
                                      {:multipart-params {:file            file
                                                          :module-name     module-name
                                                          :filename        (.-name file)
                                                          :token           token
                                                          :user-account-id nil}}))
            url (:body resp)]
        (rf/dispatch
         [(case module-name
            :lp-portal-cover-image ::set-cover-image-url
            :lp-portal-content ::set-content-url) url]))))))

(rf/reg-event-fx
 ::upload-token-failed
 (fn [{db :db} [_ resp]]
   (logging/error "Failed to create uplaod token " resp)))

;TODO: use await
(rf/reg-event-fx
 ::upload-file
 (fn [{:keys [db] :as cofx} [_ file module-name]]
   {:http-xhrio {:method          :post
                 :uri             "/lp-portal/api/create-op-token"
                 :params          {}
                 :timeout         30000
                 :format          (ajax/transit-request-format)
                 :response-format (ajax/transit-response-format)
                 :on-success      [::upload-token-created file module-name]
                 :on-failure      [::upload-token-failed]}}))

(rf/reg-event-fx
 ::start-cover-image-upload
 (fn [{:keys [db] :as cofx} [_ file]]
   {:db (assoc db :uploading-cover-image true)
    :fx [[:dispatch [::upload-file file :lp-portal-cover-image]]]}))

(rf/reg-event-fx
 ::on-reporting-contacts-data
 (fn [{:keys [db] :as cofx} [_ {:keys [body] :as args}]]
   (logging/performance "Loaded landing page guest contacts : " args)
   {:db (assoc-in db sub/landing-page-all-lp-guests-path body)}))

(rf/reg-event-fx
 ::on-reporting-contacts-failed
 (fn [{:keys [db] :as cofx} [_ args]]
   (logging/unimplemented "Failed to load reporting guests lp-portal data")
   {}))

(rf/reg-event-fx
 ::portal-guests
 (fn [{:keys [db] :as cofx} args]
   (let [role (get-in db sub/session-role-path)]
     (when (= role :role/admin)
       (logging/performance "Start load all guests")
       {:http-xhrio {:method          :post
                     :uri             "/lp-portal/api/get-reporting-contacts"
                     :params          {}
                     :timeout         30000
                     :format          (ajax/transit-request-format)
                     :response-format (ajax/transit-response-format)
                     :on-success      [::on-reporting-contacts-data]
                     :on-failure      [::on-reporting-contacts-failed]}}))))
